//*************************DO NOT MODIFY*************************************
//
//THESE FILES ARE AUTOGENERATED AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//
//*************************DO NOT MODIFY*************************************



export interface IDisciplineViewModel {
    id?: number;
    name?: string | null;
}

export class DisciplineViewModel implements IDisciplineViewModel {
    public id: number;
    public name: string | null;
}
